"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutcomeNameInBetsHistory = void 0;
const i18next_1 = __importDefault(require("i18next"));
const isParameterValueMatching_1 = require("../isParameterValueMatching");
const hasShortName_1 = require("./hasShortName");
const customizeGroupName_1 = require("./customizeGroupName");
const getOutcomeNameInBasket_1 = require("./getOutcomeNameInBasket");
const getEventProbabilityOutcomeNameV3_1 = require("./getEventProbabilityOutcomeNameV3");
const getOutcomeNameInBetsHistory = (outcome, virtualMarketInfosMap, outcomeType, clientType, players, betCompetitors, sportId, vMarketInfo, vCategoryInfo) => {
    let market;
    let categoryName;
    if (vMarketInfo && vCategoryInfo) {
        market = vMarketInfo;
        categoryName = vCategoryInfo.name;
    }
    else {
        if (!outcomeType.marketId)
            return '';
        const virtualMarketInfos = virtualMarketInfosMap[outcomeType.marketId];
        if (!virtualMarketInfos)
            return '';
        const virtualMarketInfo = virtualMarketInfos.find((virtualMarketInfo) => virtualMarketInfo.category.sportIds.includes(sportId) &&
            virtualMarketInfo.market.filteredBy.parameters.every((marketParameter) => outcome.parameters.some((pParameter) => (0, isParameterValueMatching_1.isParameterValueMatching)(pParameter, marketParameter))));
        if (!virtualMarketInfo)
            return '';
        market = virtualMarketInfo.market;
        categoryName = virtualMarketInfo.category.name;
    }
    let outcomeName = '';
    const isShortNamed = (0, hasShortName_1.hasShortName)(market, clientType);
    const templateId = market.outcomesGroup.renderTemplateId;
    outcomeName = `${categoryName}. `;
    const eventCompetitors = {
        homeCompetitors: [],
        awayCompetitors: [],
    };
    betCompetitors.forEach((betCompetitor) => {
        const competitor = betCompetitor;
        if (betCompetitor.home) {
            eventCompetitors.homeCompetitors.push(competitor);
        }
        else {
            eventCompetitors.awayCompetitors.push(competitor);
        }
    });
    const shouldAddGroupName = templateId.startsWith('L') || templateId.startsWith('SK');
    if (market.outcomesGroup.name && shouldAddGroupName) {
        outcomeName += `${(0, customizeGroupName_1.customizeGroupName)(market.outcomesGroup.name, [outcome], market, eventCompetitors)}. `;
    }
    outcomeName += (0, getEventProbabilityOutcomeNameV3_1.getEventProbabilityOutcomeNameV3)({
        eventProbability: outcome,
        market,
        players,
        templateId,
        outcomeType,
        eventCompetitors,
        isShortNamed,
    });
    if (outcomeType.marketLink &&
        getOutcomeNameInBasket_1.G2MarketLinks.includes(outcomeType.marketLink)) {
        const localeKey = getOutcomeNameInBasket_1.marketLinkToLocaleKey[outcomeType.marketLink];
        outcomeName += ` ${i18next_1.default.t(localeKey) || localeKey}`;
    }
    return outcomeName;
};
exports.getOutcomeNameInBetsHistory = getOutcomeNameInBetsHistory;
//# sourceMappingURL=getOutcomeNameInBetsHistory.js.map